<template>
  <div class="has-text-white"
    style="height: 100%; position: relative">
    <!-- <div class="is-flex is-flex-direction-row show-weekend is-hidden">
      <div class="control"
        style="width: 5em;">
        <div class="pretty p-switch p-fill">
          <input type="checkbox"
            @change="handleToggleWeekend(!isShowWeekend)"
            :checked="isShowWeekend">
          <div class="state p-primary">
            <label>Show Weekends</label>
          </div>
        </div>
      </div>
    </div> -->

    <div class="is-flex is-justify-content-space-between booking-header">
      <span>{{ selectedBooking && innerIsShowDetail ? `Vehicle No: ` + selectedBooking.vehicleRegistrationNo : 'Bookings' }}</span>
      <span v-if="!innerIsShowDetail">{{ totalBookings || 0 }}</span>

      <div style="position: absolute; top: -4px; left: -46px"
        @click="$emit('handleSidePanelToggle')">
        <div class="side-panel-slide-button">
          <span class="mdi mdi-30px"
            :class="{ 'mdi-chevron-left': !isSidePanelOpen, 'mdi-chevron-right': isSidePanelOpen, 'mdi-close': innerIsShowDetail }" />
        </div>
      </div>
    </div>

    <div class="field search-field"
      v-if="!innerIsShowDetail">
      <div class="control has-icons-right">
        <input class="input is-capitalized"
          type="text"
          placeholder="Search"
          v-model="searchTextField"
          @keyup.enter="onSearch()">
        <span v-if="!!searchTextField"
          class="icon is-right is-clickable"
          @click="clearSearch">
          <i class="mdi mdi-close has-text-white" />
        </span>
      </div>
    </div>

    <div id="myDraggable"
      class="quote-card-section thin-scrollbar"
      v-if="!innerIsShowDetail">
      <div
        v-for="booking in filteredBookings"
        class="quote-card mb-3 draggable-item"
        :key="booking.quoteBookingId"
        :data-event="JSON.stringify({ uniqueId: booking.quoteBookingId, title: booking.vehicleRegistrationNo })"
      >
        <div class="is-flex is-justify-content-space-between quote-card-header">
          <span>
            <div>
              <i class="mdi mdi-clock has-text-amber" />
              <span class="is-size-6">{{ booking.vehicleRegistrationNo }}</span>
            </div>
          </span>
          <div>
            <span class="is-size-7"> {{ $filters.formatDateTimeLocale(`${booking.createdDate}`, $userInfo.locale) }}</span>
            <!-- <a class="tooltip is-tooltip-left"
              data-tooltip="Edit"
              @click="editBooking()">
              <span class="icon has-text-primary">
                <i class="mdi mdi-pencil mdi-18px has-text-white" />
              </span>
            </a> -->
          </div>
        </div>
        <div class="quote-body">
          <div v-if="bookings.bookingType || bookings.brand"
            class="is-flex is-justify-content-space-between my-1">
            <span>{{ getNameById(storeBookingTypes, booking.bookingType) }}</span>
            <span>{{ getNameById(storeIntegrationTypes, booking.integrationType) }}</span>
          </div>
          <div class="is-flex is-justify-content-space-between vehicle-info">
            <div class="is-flex is-flex-direction-row">
              <div>{{ booking.vehicleMake }}</div>
              <div class="ml-1">{{ booking.vehicleModel }}</div>
            </div>

            <span>{{ $filters.formatCurrency(booking.excess, $userInfo.locale, false, 2) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedBooking && innerIsShowDetail"
      class="has-text-black">
      <div class="field"
        v-if="isQuote">
        <span v-if="isQuote && selectedBookingQuote.quoteIsRepairBooked"
          class="is-rounded is-success tag column is-one-third">Booked</span>
        <span v-if="isQuote && selectedBookingQuote.quoteIsAuthorised"
          class="is-rounded is-success tag ml-2 column is-one-third">Authorised</span>
      </div>
      <div class="field"
        v-if="isQuote">
        <div class="columns">
          <div class="column is-two-fifths">
            <label class="label">Total <span class="subtext">(Ex GST)</span>:</label>
          </div>
          <div class="column">
            <p>{{ selectedBookingQuote.totalExGst | formatCurrency($userInfo.locale) }}</p>
          </div>
        </div>
      </div>
      <div class="field">
        <div class="columns">
          <div class="column is-two-fifths">
            <label class="label">Claim No:</label>
          </div>
          <div class="column">
            <p>{{ selectedBooking.claimNo }}</p>
          </div>
        </div>
      </div>
      <div class="field">
        <div class="columns">
          <div class="column is-two-fifths">
            <label class="label">Quote No:</label>
          </div>
          <div class="column"
            :class="{ 'has-text-grey-light': !selectedBooking.quoteNo }">
            <a v-if="selectedBooking.quoteNo"
              @click="handleQuoteClick(selectedBooking.quoteId)">{{ selectedBooking.quoteNo }}</a>
            <p v-else>Not Quoted</p>
          </div>
        </div>
      </div>
      <div class="field pb-2">
        <div class="columns">
          <div class="column is-two-fifths">
            <label class="label">Vehicle Details:</label>
          </div>
          <div class="column">
            {{ vehicleDetails }}
          </div>
        </div>
      </div>
      <span v-if="isQuote">
        <div class="field pb-2">
          <div class="columns">
            <div class="column is-two-fifths">
              <label class="label">Customer Details:</label>
            </div>
            <div class="column">
              {{ selectedBooking.quoteCustomerName }}
            </div>
          </div>
        </div>
        <div class="field pb-2">
          <div class="columns">
            <div class="column is-two-fifths">
              <label class="label">Customer Mobile:</label>
            </div>
            <div class="column">
              {{ selectedBooking.quoteCustomerMobile }}
            </div>
          </div>
        </div>
        <div class="field"
          v-if="selectedBookingQuote.quoteIsRepairBooked != null && selectedBookingQuote.quoteIsRepairBooked">
          <label class="label">Vehicle Arrival Date</label>
          <div class="is-fullwidth">
            <v-date-picker
              v-model="innerArrivedForRepairDate"
              ref="datepicker"
              mode="dateTime"
              :minute-increment="5"
              :masks="formats"
              :attributes="attrs"
              :locale="$userInfo.locale"
              class="is-fullwidth"
              :model-config="innerArrivedForRepairDate ? {} : modelConfig"
              :timezone="$filters.getIanaTimezone()"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <div class="field has-addons">
                  <div class="control is-expanded has-icons-left">
                    <input type="text"
                      class="input"
                      placeholder="Arrive for Repair Date"
                      :value="inputValue"
                      v-on="inputEvents"
                      readonly>
                    <span class="icon is-small is-left">
                      <i class="mdi mdi-calendar mdi-18px" />
                    </span>
                  </div>
                </div>
              </template>
            </v-date-picker>
          </div>
        </div>
        <div class="field">
          <label class="label">Estimated Start Date</label>
          <input
            v-if="isRepairStartDateSynced"
            class="input is-static"
            :value="$filters.formatDateTimeLocale(selectedBookingQuote.jobStart, $userInfo.locale)"
            readonly
          >
          <v-date-picker
            v-else
            v-model="innerJobStartDate"
            ref="datepicker"
            mode="dateTime"
            :minute-increment="5"
            :masks="formats"
            :attributes="attrs"
            :locale="$userInfo.locale"
            :model-config="innerJobStartDate ? {} : modelConfig"
            :max-date="innerJobEndDate"
            :timezone="$filters.getIanaTimezone()"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <div class="field is-fullwidth">
                <div class="control has-icons-left">
                  <input
                    type="text"
                    class="input"
                    placeholder="Job Start Date"
                    :value="inputValue"
                    v-on="inputEvents"
                    :content="ormJobEndJobEndValidationText"
                    readonly
                  >
                  <span class="icon is-small is-left">
                    <i class="mdi mdi-calendar mdi-18px" />
                  </span>
                </div>
              </div>
            </template>
          </v-date-picker>
          <span class="help is-info"
            v-if="isRepx">Once the Start Date is synced, it cannot be updated.</span>
        </div>
        <div class="field">
          <label class="label">Estimated End Date</label>
          <v-date-picker
            v-model="innerJobEndDate"
            ref="datepicker"
            mode="dateTime"
            :minute-increment="5"
            :masks="formats"
            :attributes="attrs"
            :locale="$userInfo.locale"
            class="is-fullwidth"
            @input="jobEndDateInputEvent"
            :model-config="innerJobEndDate ? {} : modelConfig"
            :min-date="innerJobStartDate"
            :timezone="$filters.getIanaTimezone()"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <div class="field has-addons">
                <div class="control is-expanded has-icons-left">
                  <input
                    type="text"
                    class="input"
                    placeholder="Job End Date"
                    :value="inputValue"
                    v-on="inputEvents"
                    :content="ormJobEndJobEndValidationText"
                    readonly
                  >
                  <span class="icon is-small is-left">
                    <i class="mdi mdi-calendar mdi-18px" />
                  </span>
                </div>
              </div>
            </template>
          </v-date-picker>
        </div>
        <div class="field"
          v-if="selectedBookingQuote.quoteIsRepairBooked != null && selectedBookingQuote.quoteIsRepairBooked">
          <label class="label">Vehicle Onsite</label>
          <div class="control">
            <div class="pretty p-switch p-fill">
              <input type="checkbox"
                @change="isArrivedOnChange"
                :checked="!!innerIsArrived">
              <div class="state p-primary">
                <label>{{ innerIsArrived ? 'Yes' : 'No' }}</label>
              </div>
            </div>
          </div>
        </div>
      </span>
      <span v-else>
        <div class="field mt-5">
          <label class="label">Inspection Booking Date</label>
          <div class="is-fullwidth">
            <v-date-picker
              v-model="innerBookingStartDateTime"
              :masks="formats"
              :attributes="attrs"
              :model-config="modelConfig"
              :locale="$userInfo.locale"
              :timezone="$filters.getIanaTimezone()"
              :min-date="minDate"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <div class="field">
                  <div class="control has-icons-left">
                    <input
                      type="text"
                      class="input"
                      placeholder="Date"
                      :value="inputValue"
                      v-on="inputEvents"
                      :disabled="isQuote"
                      :class="{ 'is-invalid': $v.innerBookingStartDateTime.$dirty && !$v.innerBookingStartDateTime.required }"
                    >
                    <span class="icon is-small is-left">
                      <i class="mdi mdi-calendar mdi-18px" />
                    </span>
                  </div>
                </div>
              </template>
            </v-date-picker>
          </div>
          <!-- <v-date-picker
          v-model="selectedBooking.bookingStartDateTime"
          mode="dateTime"
          ref="innerBookingStartDateTime"
          :minute-increment="30"
          :masks="formats"
          :attributes="attrs"
          :locale="$userInfo.locale"
          class="is-fullwidth"
          :model-config="innerBookingStartDateTime ? {} : {}"
          :timezone="$filters.getIanaTimezone()"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <div class="field has-addons">
              <div class="control is-expanded has-icons-left">
                <input
                  type="text"
                  class="input"
                  placeholder="Booking Date"
                  :value="inputValue"
                  v-on="inputEvents"
                  readonly
                  :disabled="selectedBooking.quoteId"
                >
                <span class="icon is-small is-left">
                  <i class="mdi mdi-calendar mdi-18px" />
                </span>
              </div>
            </div>
          </template>
        </v-date-picker> -->
        </div>
        <div class="field">
          <label class="label">Inspection Booking Time</label>
          <div class="control is-extended">
            <div class="select is-fullwidth"
              :class="{ 'is-invalid': $v.innerBookingStartTime.$dirty && !$v.innerBookingStartTime.required }">
              <select ref="insepctionBookingTime"
                v-model="innerBookingStartTime"
                :disabled="isQuote">
                <option value="null"
                  disabled>Select</option>
                <option v-for="(s, index) in inspectionBookingTimeSlots"
                  :key="index"
                  :value="extractTimeOnly(s)">
                  {{ extractTimeOnly(s) }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </span>

      <div class="field is-grouped is-justify-content-space-between mt-5">
        <div class="control">
          <button class="button is-primary"
            data-tooltip="View Booking"
            @click="isQuote ? handleQuoteClick(selectedBooking.quoteId) : handleBookingRedirect()">
            <span>{{ isQuote ? 'View Quote' : 'View Booking' }}</span>
          </button>
        </div>
        <div class="control">
          <button class="button is-success tooltip"
            @click="isQuote ? handleQuoteSave() : save()"
            data-tooltip="Save changes">
            <span class="icon">
              <i class="mdi mdi-content-save mdi-18px" />
            </span>
            <span>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BookingService from './BookingService'
import { mapGetters } from 'vuex'
import BookingRoutes from './route-types'
import { required } from 'vuelidate/lib/validators'
import { DateTime } from 'luxon'
import QuoteRoutes from '../quote/route-types'
import JobStageTypes from '@/enums/JobStageTypes'
import QuoteService from '../quote/QuoteService'
import { NumberFiltersMixin } from '@/components/mixins/filters'
import { requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'BookingCalendarSidePanel',
  components: {},
  mixins: [NumberFiltersMixin],
  props: {
    isSidePanelOpen: {
      type: Boolean,
      required: true
    },
    isShowDetail: {
      type: Boolean,
      required: true
    },
    bookingId: null
  },
  data() {
    return {
      searchTextField: null,
      selectedSort: '0',
      bookings: [],
      filteredBookings: [],
      isShowWeekend: true,
      selectedBooking: null,
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        data: ['L', 'DD-MM-YYYY', 'DD/MM/YYYY'],
        dayPopover: 'L'
      },
      attrs: [
        {
          key: 'today',
          highlight: {
            backgroundColor: '#ff8080'
          },
          popover: {
            label: 'Today'
          },
          dates: new Date()
        }
      ],
      modelConfig: {},
      innerBookingStartTime: null,
      inspectionBookingTimeSlots: [],
      innerBookingStartDateTime: null,
      innerBookingId: null,
      isFirstLoad: false,
      innerIsShowDetail: false,
      innerArrivedForRepairDate: null,
      innerJobStartDate: null,
      innerJobEndDate: null,
      innerIsArrived: false,
      sortKey: null,
      bookedInSortKey: null,
      selectedBookingQuote: null
    }
  },
  computed: {
    totalBookings() {
      return this.bookings.length
    },
    ...mapGetters('booking', {
      storeIntegrationTypes: 'integrationTypes',
      storeBookingTypes: 'bookingTypes'
    }),
    minDate() {
      const today = new Date()
      return today
    },
    vehicleDetails() {
      return [this.selectedBooking.vehicleYear ?? '', this.selectedBooking.vehicleMake ?? '', this.selectedBooking.vehicleModel ?? ''].join(' ')
    },
    isQuote() {
      return !!(this.selectedBooking && this.selectedBooking.quoteId)
    },
    isRepairStartDateSynced() {
      return this.selectedBooking.isRepairStartDateSynced
    },
    isRepx() {
      return this.selectedBooking.isRepx
    },
    quoteValidateError() {
      this.$v.$touch()
      return (
        !this.$v.innerJobStartDate.validJobStart ||
        !this.$v.innerJobEndDate.validJobEnd
      )
    }
  },
  validations: {
    innerBookingStartDateTime: {
      required
    },
    innerBookingStartTime: {
      required
    },
    innerJobStartDate: {
      required: requiredIf(function (model) {
        return this.isQuote ? (this.selectedBookingQuote.isORM || this.innerJobEndDate): false
      }),
      validJobStart: function (value, model) {
        return this.isQuote ? (value <= this.innerJobEndDate) : true
      }
    },
    innerJobEndDate: {
      required: requiredIf(function (model) {
        return this.isQuote  ?(this.selectedBookingQuote.isORM  || this.innerJobStartDate): false
      }),
      validJobEnd: function (value, model) {
        return this.isQuote ?  (value >= this.innerJobStartDate): true
      }
    }
  },
  watch: {
    bookingId: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.getEntity(newVal)
        }
      },
      deep: true
    },
    // bookingStartDateTime: {
    //   handler: async function (newVal, oldVal) {
    //     if (newVal !== oldVal) {
    //       await this.getAvailableTimeSlots(newVal)
    //     }
    //   }
    // },
    innerBookingStartDateTime: {
      handler: async function (newVal, oldVal) {
        // if (this.innerBookingId == null) {
        //   this.innerBookingId = this.selectedBooking.quoteBookingId
        // }
        if (newVal && newVal !== oldVal) {
          await this.getAvailableTimeSlots(newVal)
        }
      }
    },
    isShowDetail: {
      handler: function (newVal, oldVal) {
        this.innerIsShowDetail = newVal
      }
    },
    innerArrivedForRepairDate: function (newVal, oldVal) {
      if (newVal) {
        this.selectedBookingQuote.quoteCycleTime.arrivedForRepairDate = newVal.toISOString().split('.')[0] + 'Z'
        if (this.selectedBookingQuote.quoteCycleTime.arrivedForRepairDate && oldVal == null) {
          this.selectedBookingQuote.jobStage = JobStageTypes.VehicleArrived
        }
      } else {
        this.selectedBookingQuote.quoteCycleTime.arrivedForRepairDate = null
      }
      this.innerIsArrived = this.selectedBookingQuote.quoteCycleTime.arrivedForRepairDate != null
    },
    innerJobStartDate: function (newVal, oldVal) {
      if (newVal) {
        this.selectedBookingQuote.jobStart = newVal.toISOString().split('.')[0] + 'Z'
        if (this.selectedBookingQuote.jobEnd && this.sortKey < this.bookedInSortKey && this.selectedBookingQuote.autoBookedInForDueInOut) {
          this.selectedBookingQuote.jobStage = JobStageTypes.BookedIn
        }
      } else {
        this.selectedBookingQuote.jobStart = null
      }
    },
    innerJobEndDate: function (newVal, oldVal) {
      if (newVal) {
        this.selectedBookingQuote.jobEnd = newVal.toISOString().split('.')[0] + 'Z'
        this.isRepairLateReasonActive = this.compare1DateTo2(newVal, this.selectedBookingQuote.jobEnd)
        if (this.selectedBookingQuote.jobStart && this.sortKey < this.bookedInSortKey && this.selectedBookingQuote.autoBookedInForDueInOut) {
          this.selectedBookingQuote.jobStage = JobStageTypes.BookedIn
        }
      } else {
        this.selectedBookingQuote.jobEnd = null
      }
    }
  },
  async created() {
    this.$store.dispatch('booking/load')
    this.refresh()
  },
  async mounted() {},
  methods: {
    async refresh() {
      this.bookings = await this.getBookings()
      this.filteredBookings = this.bookings
    },
    async getBookings() {
      const data = await BookingService.getBookings()
      return data
    },
    async getEntity(bookingId) {
      console.log('getEntity', bookingId)
      const data = await BookingService.getEntity(bookingId)
      this.selectedBooking = data
      this.innerBookingId = this.selectedBooking.quoteBookingId
      this.innerBookingStartDateTime = data.bookingStartDateTime
      if (this.innerBookingStartDateTime) {
        // await this.getAvailableTimeSlots(bookingId, this.innerBookingStartDateTime)
        let timezoneStartDate = this.$filters.formatISOToLuxon(this.innerBookingStartDateTime, null)
        const timeOnly = this.$filters.formatISOToString(timezoneStartDate, null, 'h:mm a')
        this.innerBookingStartTime = timeOnly
        this.isFirstLoad = true
      }
      if(data.bookingQuote){
        this.selectedBookingQuote = data.bookingQuote
        this.sortKey = this.getJobStageSortKey(this.selectedBookingQuote.jobStage)
        this.bookedInSortKey = this.getJobStageSortKey(JobStageTypes.BookedIn)
        this.innerJobStartDate = this.selectedBookingQuote.jobStart ? new Date(`${this.selectedBookingQuote.jobStart}`) : null
        this.innerJobEndDate = this.selectedBookingQuote.jobEnd ? new Date(`${this.selectedBookingQuote.jobEnd}`) : null
        this.innerArrivedForRepairDate = this.selectedBookingQuote.quoteCycleTime && this.selectedBookingQuote.quoteCycleTime.arrivedForRepairDate ? new Date(`${this.selectedBookingQuote.quoteCycleTime.arrivedForRepairDate}`) : null
      }
      return data
    },
    getNameById(array, id) {
      const item = array.find((element) => element.id === id)
      return item ? item.name : null // Return the name if found, otherwise null
    },
    handleToggleWeekend(isShow) {
      this.isShowWeekend = isShow
      this.$emit('toggleWeekend', this.isShowWeekend)
    },
    remove(id) {
      if (this.filteredBookings) {
        let indexToRemove = this.filteredBookings.findIndex((item) => item.quoteBookingId === id)
        if (indexToRemove !== -1) {
          this.filteredBookings.splice(indexToRemove, 1)
        }
      }
    },
    async filterBookings() {
      if (!this.searchTextField) {
        this.filteredBookings = this.bookings
      } else {
        const text = this.searchTextField.toLowerCase()
        let filtered = this.bookings.filter((i) => {
          const regex = new RegExp(text, 'i')
          return Object.values(i).some((value) => regex.test(String(value)))
        })
        this.filteredBookings = filtered
      }
    },
    onSearch() {
      this.filterBookings()
    },
    clearSearch() {
      this.searchTextField = null
      this.filterBookings()
    },
    handleBookingRedirect() {
      this.$router.push({
        path: BookingRoutes.BookingView.path.replace(':bookingId', this.bookingId)
      })
    },
    save() {
      this.$v.$touch()
      if (this.$v.$error) {
        console.error('Validation errors', this.$v)
        this.$notification.openNotificationWithType('danger', 'Booking', 'Validation errors. Please fix before saving')
        this.showItemsValidationErrors()
        return false
      }
      if (!this.innerBookingId) return false

      const timeOnly = DateTime.fromFormat(this.innerBookingStartTime, 'h:mm a')
      const isJsDate = this.isJsDate(this.innerBookingStartDateTime) //this.innerBookingStartDateTime instanceof Date
      const innerStartDate = isJsDate ? this.innerBookingStartDateTime.toISOString() : this.innerBookingStartDateTime
      const luxonDateTime = this.$filters.formatISOToLuxon(innerStartDate, null).set({ hour: timeOnly.hour, minute: timeOnly.minute })
      const offsetMinutes = -1 * new Date().getTimezoneOffset()
      const lxDateTime = luxonDateTime.plus({ minutes: offsetMinutes })
      let customDate = new Date(lxDateTime.year, lxDateTime.month - 1, lxDateTime.day, lxDateTime.hour, lxDateTime.minute, lxDateTime.second)

      this.$emit('handleBookingDateChange', this.innerBookingId, customDate)
    },
    isJsDate(date) {
      return date instanceof Date
    },
    showItemsValidationErrors() {
      if (this.$v.innerBookingStartDateTime.$invalid) {
        this.$v.innerBookingStartDateTime.$touch()
      }
      if (this.$v.innerBookingStartTime.$invalid) {
        this.$v.innerBookingStartTime.$touch()
      }
    },
    async getAvailableTimeSlots(inspectionBookingDate) {
      const isJsDate = this.isJsDate(inspectionBookingDate)
      const isoSelectedDate = isJsDate ? this.getLocalISODateTime(inspectionBookingDate) : inspectionBookingDate
      const datas = await BookingService.getAvailableTimeSlots(this.bookingId, isoSelectedDate)
      this.inspectionBookingTimeSlots = datas
      if (this.isFirstLoad) {
        this.isFirstLoad = false
      } else {
        this.innerBookingStartTime = null
      }
    },
    // handleBookingDateChange(date) {
    //   this.$emit('handleBookingDateChange', date)
    //   // this.$router.push({
    //   //   path: BookingRoutes.BookingView.path.replace(':bookingId', this.bookingId)
    //   // })
    // },
    extractTimeOnly(dateStr) {
      const date = new Date(dateStr)
      const timeOnly = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
      return timeOnly
    },
    resetDetailsSection() {
      this.selectedBooking = null
      this.inspectionBookingTimeSlots = []
      this.innerBookingStartDateTime = null
      this.innerBookingStartTime = null
      this.innerBookingId = null
      this.innerIsShowDetail = false
    },
    getLocalISODateTime(date) {
      const offset = date.getTimezoneOffset() * 60000 // Convert minutes to milliseconds
      const localISOTime = new Date(date - offset).toISOString()
      return localISOTime
    },
    // convertToISO(date) {
    //   if (date instanceof Date && !isNaN(date)) {
    //     return DateTime.fromJSDate(date).toISO()
    //   }
    //   const dt = DateTime.fromISO(date, { zone: 'utc' })
    //   return dt.isValid ? dt.toISO() : null
    // }
    // handleQuoteRedirect(quote) {
    //   this.$emit('handleQuoteRedirect', quote)
    // },
    // editBooking() {
    //   this.$emit('editBooking')
    // }
    handleQuoteClick(quoteId) {
      var route = QuoteRoutes.QuoteView.path.replace(':quoteId', quoteId)
      this.$router.push(`${route}`)
    },
    jobEndDateInputEvent(event) {},
    isArrivedOnChange(event) {
      this.innerIsArrived = !!event.target.checked
      if (!this.innerIsArrived) {
        if (this.innerArrivedForRepairDate !== null) {
          this.innerArrivedForRepairDate = null
          this.innerIsArrived = false
        }
      } else {
        this.innerArrivedForRepairDate = new Date()
      }
    },
    handleQuoteSave() {
      const title = 'Quote'
      if (this.quoteValidateError) {
        this.$notification.openNotificationWithType('danger', title, 'Validation errors. Please fix before saving')
        return false
      }
      this.$emit('handleQuoteDateChange', this.selectedBooking.quoteId, this.selectedBookingQuote)
    },
    ormJobEndJobEndValidationText() {
      if (!this.$v.innerJobStartDate.required || this.$v.innerJobEndDate.required) {
        return 'Required by ORM'
      } else if (!this.$v.innerJobStartDate.validJobStart || !this.$v.innerJobEndDate.validJobEnd) {
        return 'Invalid date range'
      }
    },
    async getJobStageSortKey(stageId) {
      if (!stageId) return 0
      const jobStage = await QuoteService.getJobStages()
      const index = jobStage.findIndex((i) => i.stage === stageId)
      const sortKey = jobStage[index].sortKey
      return sortKey
    },
    compare1DateTo2(dateStr1, dateStr2) {
      if (dateStr1 && dateStr2) {
        const date1 = new Date(dateStr1)
        const date2 = new Date(dateStr2)

        if (date1 > date2) {
          return true
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss">
.show-weekend {
  margin-bottom: 1em;
}

.booking-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  font-size: 20px;
  font-weight: 700;
  color: #58a1e8;
  padding-bottom: 1em;
  border-bottom: 2px solid #58a1e8;
  margin-bottom: 1em;
}

.search-field-dark {
  .select select,
  .textarea,
  .input {
    background-color: #495057;
    border: #495057;
    color: #fff;
    &::placeholder {
      color: rgb(255, 255, 255, 0.5);
    }
  }
}

.quote-card-section {
  height: 79%;
  overflow-y: auto;
  // padding-right: 0.25em;
}

.quote-card {
  width: 100%;
  background: #004a95;
  border: solid 1px #dee7f1;
  border-radius: 0.3em;
  color: #fff;
  cursor: pointer;
  // opacity: 0.8;

  &:hover {
    opacity: 1;
    transition: all 0.25s ease-in-out;
  }

  .quote-card-header {
    width: 100%;
    padding: 0.3em 0.5em;
    background-color: #fff;
    color: #000;
    border-top-left-radius: 0.2em;
    border-top-right-radius: 0.2em;
  }

  .quote-body {
    padding: 0.5em 0.6em;
    font-size: 14px;
    background-color: #ffc107;
    color: #000;
    border-bottom-left-radius: 0.2em;
    border-bottom-right-radius: 0.2em;
  }
}

.side-panel-slide-button {
  background-color: #2874bf;
  color: #fff;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    transition: all 0.25s ease-in-out;
    background-color: #058cba;
  }
}

.booking-panel i.mdi-clock {
  font-size: 1.1em;
}

.subtext {
  font-size: 10px;
}
</style>
